import { Cid10, TipoAtestadoEnum } from 'graphql/types.generated'
import { porExtenso } from 'numero-por-extenso'
import { formatDate } from 'util/date/formatDate'

import AtestadoModel, { CidadaoAtestado } from '../components/model-atestado'
import {
  buildCid10Substring,
  buildCpfCnsSubstring,
  buildDocumentoSubstring,
  buildNomeSubstring,
} from '../utils-atestado'

type GetAtestadoPadraoTextParams = {
  cidadao: CidadaoAtestado
  nomeUnidadeSaude: string
  values?: AtestadoModel
}

type BuildAtestadoPadraoTextParams = BuildAtestadoPadraoParams & {
  documento?: string
}

type BuildAtestadoPadraoParams = {
  cidadao: CidadaoAtestado
  nomeUnidadeSaude: string
  data: string
  hora?: string
  cid10?: Cid10
  dias?: number
}

const buildDataSubstring = (data: LocalDate | undefined): string => (data ? formatDate(data) : '[DATA]')

const buildHoraSubstring = (hora: string | undefined): string => {
  if (!hora) {
    return '[HORA]'
  }

  return hora
}

const buildDiasSubstring = (dias: number | string | undefined): string => {
  if (!dias) return '[DIAS]'

  const diasLabel = dias.toString() === '1' ? 'dia' : 'dias'

  return `${dias} (${porExtenso(dias)}) ${diasLabel}`
}

const buildAtestadoPadraoText = ({
  cidadao,
  nomeUnidadeSaude,
  documento,
  data,
  hora,
  cid10,
  dias,
}: BuildAtestadoPadraoTextParams): string => {
  const nome = buildNomeSubstring(cidadao)
  const documentoSubstring = buildDocumentoSubstring(documento)
  const horaSubstring = buildHoraSubstring(hora)
  const cid10Substring = buildCid10Substring(cid10)
  const diasSubstring = buildDiasSubstring(dias)

  return (
    `Atesto, para os devidos fins, que ${nome}${documentoSubstring} ` +
    `recebeu atendimento na ${nomeUnidadeSaude} no dia ${data} às ${horaSubstring}${cid10Substring}. ` +
    `Em decorrência, deverá permanecer em afastamento de suas atividades laborativas ` +
    `por um período de ${diasSubstring} a partir desta data.`
  )
}

export const getAtestadoPadraoText = ({ cidadao, nomeUnidadeSaude, values }: GetAtestadoPadraoTextParams): string =>
  buildAtestadoPadraoText({
    cidadao,
    nomeUnidadeSaude,
    documento: buildCpfCnsSubstring(cidadao, values?.cpfCns, values?.naoPossui),
    data: buildDataSubstring(values?.data),
    hora: values?.hora,
    cid10: values?.cid10,
    dias: values?.dias,
  })

export const buildAtestadoPadrao = ({
  cidadao,
  nomeUnidadeSaude,
  data,
  hora,
  cid10,
  dias,
}: BuildAtestadoPadraoParams): AtestadoModel => {
  const cpfCns = cidadao.cpf ?? cidadao.cns
  const naoPossui = !cpfCns
  const atestado: AtestadoModel = { tipo: TipoAtestadoEnum.PADRAO, cpfCns, naoPossui, data, hora, cid10, dias }

  return {
    ...atestado,
    descricao: getAtestadoPadraoText({ cidadao, nomeUnidadeSaude, values: atestado }),
  }
}
